import React, { useState, useEffect, useRef } from 'react';
import Icon from '../AppIcon';

const WhatsAppWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const popupRef = useRef(null);

  const countries = [
    {
      name: 'Nigeria',
      flag: '🇳🇬',
      number: '+2349160085052',
      timezone: 'WAT (UTC+1)'
    },
    {
      name: 'Cameroon',
      flag: '🇨🇲',
      number: '+237650616290',
      timezone: 'WAT (UTC+1)'
    },
    {
      name: 'South Africa',
      flag: '🇿🇦',
      number: '+27618159013',
      timezone: 'SAST (UTC+2)'
    }
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef?.current && !popupRef?.current?.contains(event?.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleWhatsAppClick = (number) => {
    const message = encodeURIComponent('Hello Edrian, I would like to discuss your services.');
    window.open(`https://wa.me/${number?.replace(/\+/g, '')}?text=${message}`, '_blank');
    setIsOpen(false);
  };

  if (!isVisible) return null;

  return (
    <div className="whatsapp-widget">
      {isOpen && (
        <div className="whatsapp-popup" ref={popupRef}>
          <div className="whatsapp-popup-header">
            <div className="flex items-center gap-2">
              <Icon name="MessageCircle" size={20} color="var(--color-primary)" />
              <span className="font-semibold">Start a Conversation</span>
            </div>
            <button
              onClick={() => setIsOpen(false)}
              className="w-6 h-6 flex items-center justify-center rounded hover:bg-muted transition-colors"
              aria-label="Close WhatsApp popup"
            >
              <Icon name="X" size={16} color="currentColor" />
            </button>
          </div>

          <p className="text-sm text-muted-foreground mb-4">
            Choose your preferred region to connect via WhatsApp
          </p>

          <div className="space-y-2">
            {countries?.map((country) => (
              <div
                key={country?.number}
                className="whatsapp-country-option"
                onClick={() => handleWhatsAppClick(country?.number)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e?.key === 'Enter' && handleWhatsAppClick(country?.number)}
              >
                <span className="text-2xl">{country?.flag}</span>
                <div className="flex-1">
                  <div className="font-medium">{country?.name}</div>
                  <div className="text-xs text-muted-foreground">{country?.number}</div>
                </div>
                <Icon name="ExternalLink" size={16} color="var(--color-muted-foreground)" />
              </div>
            ))}
          </div>

          <div className="mt-4 pt-4 border-t border-border">
            <p className="text-xs text-muted-foreground text-center">
              Available Mon-Fri, 9AM-6PM (Local Time)
            </p>
          </div>
        </div>
      )}
      <button
        className="whatsapp-button"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Open WhatsApp contact options"
        aria-expanded={isOpen}
      >
        <Icon name="MessageCircle" size={28} color="white" />
      </button>
    </div>
  );
};

export default WhatsAppWidget;